import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { useContextSelector } from "use-context-selector"
import { AppCurrencyContext } from "app/providers"

import { GLOBAL } from 'app/@common/constants'


export default function SelectCurrency({ ...props }) {

    const currency = useContextSelector(AppCurrencyContext, ({state}) => state.currency)
    const setCurrency = useContextSelector(AppCurrencyContext, ({replaceState}) => replaceState)

    const myProps = {
        urlAjax: GLOBAL.CURRENCY_HEADER,
        value: currency,
        firstSelect: true,
        onChange: ({ value }) => setCurrency({ currency: value }),
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}